import * as React from "react";
import { Switch as SwitchPrimitive } from "radix-ui";
import { cn } from "@/shared/utils/utils";

const Switch = ({
  className,
  size = "default",
  thumbCss,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: "sm" | "default";
  thumbCss: string;
}): React.ReactElement => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "peer data-[state=checked]:bg-primary p-0.5 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-white data-[state=unchecked]:bg-border dark:data-[state=unchecked]:bg-border group/switch inline-flex shrink-0 items-center rounded-full transition-all disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-5 data-[size=default]:w-10 data-[size=sm]:h-3.5 data-[size=sm]:w-6",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block rounded-full ring-0 transition-transform",
          "data-[state=checked]:bg-switch-thumb",
          "data-[state=unchecked]:bg-switch-thumb",
          "group-data-[size=default]/switch:size-4",
          "group-data-[size=sm]/switch:size-3",
          "data-[state=checked]:translate-x-[125%]",
          "data-[state=unchecked]:translate-x-[2%]",
          thumbCss,
        )}
      />
    </SwitchPrimitive.Root>
  );
};

export { Switch };
